import API from 'config/Axios';

export const FinishTransaction = (orderId) => {
  return API.patch(`/staff/orders/finish/${orderId}`);
};
